import { render, staticRenderFns } from "./AgregaRatificante.vue?vue&type=template&id=6ba3b3d4&scoped=true"
import script from "./AgregaRatificante.vue?vue&type=script&lang=js"
export * from "./AgregaRatificante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba3b3d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba3b3d4')) {
      api.createRecord('6ba3b3d4', component.options)
    } else {
      api.reload('6ba3b3d4', component.options)
    }
    module.hot.accept("./AgregaRatificante.vue?vue&type=template&id=6ba3b3d4&scoped=true", function () {
      api.rerender('6ba3b3d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/infoBase/modales/AgregaRatificante.vue"
export default component.exports